import { Button, Card, ListItemText, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { BIBlue, BILightGrey, BIWhite } from "../../assets/helpers";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_PROFILE_BOARD_DATA,
  FETCH_USERS_WORK_HISTORY2,
  GET_COMMON_PROJECTS
} from "../../constant/Apipath";
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { Edit as EditIcon } from "@mui/icons-material";
import moment from "moment";
import defaultProjectImage from "../../assets/images/placeholder_img.jpg";
import Addcompany from "./Addcompany";
import AddIcon from "@mui/icons-material/Add";
import {
  setSelectedcompany,
  setSelectedProjectdata,
  setSelectedsite,
  setShowaddexperience,
  setShowmapmodal
} from "../../redux/actions/actions";
import Loader from "../../common/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { Getrequestcall } from "../../request/Getrequest";
import mapMarkerYellow from "../../assets/images/marker_yellow.png";
import Viewexperience from "./Viewexperience";
import { English } from "../../constant/EnglishFallback";
import EducationSekeleton from "./EducationSkeleton";

export default function Experience({
  profileLoading,
  setProfileLoading,
  profileSectionLoadingState,
  setProfileSectionLoadingState
}) {
  const { loginData, selectedProject, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId } = useParams();
  const [company, setCompany] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [sites, setSites] = useState([]);
  // const [editExperience, setEditexperience] = useState(false);
  const [editExperience, setEditexperience] = useState(
    loginData?.userInformation?.UserId == userId ? true : false
  );
  const [siteFlag, setSiteFlag] = useState(false);
  const [showAddcompany, setShowaddcompany] = useState(false);
  const [companyId, setCompanyId] = useState(0);
  const [addExperience, setAddexperience] = useState(false);
  const [showMyExperienceHeading, setShowMyExperienceHeading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [workHistoryCommonSites, setWorkHistoryCommonSites] = useState([]);
  const [isFormUserDashboard, setIsFormUserDashboard] = useState(false);

  const [projectData, setProjectdata] = useState({});
  const [viewExperience, setViewexperience] = useState(false);
  const [shouldUpdateData, setShouldUpdateData] = useState(false);

  const {
    BUTTON_EDIT = English?.Profile?.BUTTON_EDIT,
    TEXT_PRESENT = English?.Profile?.TEXT_PRESENT,
    BUTTON_BACK = English?.Profile?.BUTTON_BACK,
    TEXT_MY_EXPERIENCE_HEADING = English?.Profile?.TEXT_MY_EXPERIENCE_HEADING,
    TEXT_EXPERIENSE_INFO = English?.Profile?.TEXT_EXPERIENSE_INFO,
    BUTTON_ADD_MY_EXPERIENCE = English?.Profile?.BUTTON_ADD_MY_EXPERIENCE,
    TEXT_ADD_COMPANY = English?.Profile?.TEXT_ADD_COMPANY,
    BUTTON_VIEW_BY_COMPANY = English?.Profile?.BUTTON_VIEW_BY_COMPANY,
    BUTTON_VIEW_BY_SITES = English?.Profile?.BUTTON_VIEW_BY_SITES,
    TEXT_EXPERIENCE_DESCRIPTION = English?.Profile?.TEXT_EXPERIENCE_DESCRIPTION,
    TEXT_ADD_PROJECT = English?.Profile?.TEXT_ADD_PROJECT,
    TEXT_EDIT_COMPANY = English?.Profile?.TEXT_EDIT_COMPANY,
    TEXT_EDIT_PROJECT = English?.Profile?.TEXT_EDIT_PROJECT,
    TEXT_NO_COMPANY = English?.Profile?.TEXT_NO_COMPANY
  } = multiLanguageData?.Profile || {};

  useEffect(() => {
    getExperience();
    if (loginData?.userInformation?.UserId !== Number(userId)) {
      setIsFormUserDashboard(true);
      fetchCommonProjectDetails();
    } else {
      setIsFormUserDashboard(false);
    }
  }, [userId]);

  useEffect(() => {
    if (selectedProject?.type === "delete" || selectedProject?.type === "update") {
      getExperience();
    }
  }, [selectedProject]);

  const getExperience = async () => {
    try {
      setLoader(true);
      setProfileSectionLoadingState((prev) => ({
        ...prev,
        experienceLoader: true
      }));
      const workHistoryObj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        NrOfRecPerPage: 20,
        UserId: Number(userId),
        SearchList: [{ UserId: Number(userId) }],
        SortList: [{ FieldName: "id", Direction: "DESC" }]
      };

      const workHistoryRes = await Postrequestcall(
        FETCH_PROFILE_BOARD_DATA,
        workHistoryObj,
        loginData?.accessToken
      );

      const workHistory = workHistoryRes?.data?.data;

      if (!workHistory) {
        setCompany([]);
        setAllCompanies([]);
        setSites([]);
        setAddexperience(false);
        setLoader(false);
        return;
      }

      const companyData = workHistory.userCompanyHistory || [];
      const noCompanyData = workHistory.noCompanyHistory || [];

      const experienceDataBySite = processExperienceDataBySite(companyData);

      const processedCompanyData = processCompanyData(companyData);

      const noCompanyEntry = createNoCompanyEntry(noCompanyData, userId);

      const finalTransform = noCompanyEntry
        ? [...processedCompanyData, noCompanyEntry]
        : processedCompanyData;

      setCompany(finalTransform);
      setAllCompanies(processedCompanyData);
      setSites(experienceDataBySite);
      setAddexperience(finalTransform?.length === 0 && experienceDataBySite?.length === 0);
      setLoader(false);
      setProfileSectionLoadingState((prev) => ({
        ...prev,
        experienceLoader: false
      }));
    } catch (error) {
      console.error("getExperience-> Error While Getting Experience Data: ", error);
      setCompany([]);
      setAllCompanies([]);
      setSites([]);
      setAddexperience(false);
      setLoader(false);
      setProfileSectionLoadingState((prev) => ({
        ...prev,
        experienceLoader: false
      }));
    }
  };

  const processExperienceDataBySite = (companyData) => {
    if (!companyData.length) return [];

    const dataBySite = [];
    const siteIds = new Set();

    companyData.forEach((company) => {
      company.userExperienceList?.forEach((item) => {
        dataBySite.push(item);
        siteIds.add(item.siteId);
      });
    });

    return Array.from(siteIds).map((siteId) => {
      const siteItem = dataBySite.find((item) => item.siteId === siteId);
      return {
        companyName: siteItem?.siteName || "",
        roleName: siteId === 0 ? "No site" : "",
        id: siteId,
        startDate: null,
        data: dataBySite.filter((item) => item.siteId === siteId)
      };
    });
  };

  const processCompanyData = (companyData) => {
    if (!companyData.length) return [];

    return companyData.map((item) => {
      const uniqueRoles = [
        ...new Set(item.userExperienceList?.map((exp) => exp.roleName).filter(Boolean) || [])
      ];

      return {
        ...item,
        data: item.userExperienceList || [],
        roleName: uniqueRoles.join(", "),
        userExperienceList: undefined
      };
    });
  };

  const createNoCompanyEntry = (noCompanyData, currentUserId) => {
    if (!noCompanyData?.length) return null;

    const uniqueRoles = [...new Set(noCompanyData.map((item) => item.roleName).filter(Boolean))];

    if (!uniqueRoles.length) return null;

    return {
      id: 0,
      userId: Number(currentUserId),
      userName: "John Snow",
      companyId: 14,
      companyName: "No Company",
      roleId: 252,
      roleName: uniqueRoles.join(", "),
      startDate: null,
      endDate: null,
      includeInResume: false,
      currentCompany: false,
      description: "",
      data: noCompanyData
    };
  };

  const fetchCommonProjectDetails = async () => {
    try {
      const getCommonSites = await Getrequestcall(
        `${GET_COMMON_PROJECTS}/${loginData?.userInformation?.UserId}/${userId}`,
        loginData?.accessToken
      );
      setWorkHistoryCommonSites(getCommonSites?.data?.data);
    } catch (error) {
      console.log("fetchCommonProjectDetails-> Error While Fetching Common Projects: ", error);
    }
  };

  const handleExperience = () => {
    setEditexperience(!editExperience);
  };

  const viewList = () => {
    if (!siteFlag) {
      setAddexperience(sites?.length === 0 ? true : false);
    } else {
      setAddexperience(company?.length === 0 ? true : false);
    }
    setSiteFlag(!siteFlag);
  };

  const onCompanyedit = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    setCompanyId(item?.companyId);
    setShowaddcompany(true);
  };

  const onAddProject = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(setSelectedsite(null));
    dispatch(setSelectedcompany(item)); // store the company details in redux
    let mapModal = {
      open: true,
      from: "experience",
      select: "project"
    };
    dispatch(setShowmapmodal(mapModal));
  };

  const onAddexperience = () => {
    if (siteFlag) {
      setSiteFlag(false);
    }
    setAddexperience(false);
    setShowMyExperienceHeading(true);
  };

  const onProjectedit = (e, item, comp) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(setSelectedcompany(comp)); // store the company details in redux
    let getObj = { ...item, type: "edit", from: "experience" };
    dispatch(setSelectedProjectdata(getObj)); // Store the project data for edit
    dispatch(setShowaddexperience(true)); // Store the experience data
  };

  const onProjectselect = (e, item, comp) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(setSelectedcompany(comp)); // store the company details in redux
    setProjectdata(item);
    setViewexperience(true);
  };

  const handleClose = () => {
    setShowaddcompany(false);
    setCompanyId(0);
  };

  const onCompanyselect = (comp) => {
    if (comp?.manufacturer === true) {
      navigate(`/manufacture/${comp?.companyId}`);
    } else {
      navigate(`/company/${comp?.companyId}`);
    }
  };

  if (profileSectionLoadingState?.experienceLoader) {
    return <EducationSekeleton />;
  }

  return (
    <>
      <Card
        className="pagelist-content"
        style={{ maxHeight: loader ? "" : "45vh", overflow: "scroll", scrollbarWidth: "none" }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{
            padding: "10px",
            position: "sticky",
            top: "0px",
            background: "white",
            width: "auto",
            zIndex: "1"
          }}>
          <Typography variant="h6">
            {editExperience || showMyExperienceHeading
              ? TEXT_MY_EXPERIENCE_HEADING
              : TEXT_EXPERIENSE_INFO}
          </Typography>
          {isFormUserDashboard ? null : (
            <>
              {/* {addExperience ? (
                <>
                  <Button
                    variant="contained"
                    sx={{ width: "fit-content" }}
                    className="action-button"
                    onClick={onAddexperience}>
                    {BUTTON_ADD_MY_EXPERIENCE}
                  </Button>
                </>
              ) : ( */}
              <Stack flexDirection={"row"} gap={2} pb={1}>
                {/* {(company?.length !== 0 || sites?.length !== 0) && (
                    <Button
                      variant="contained"
                      sx={{ width: "fit-content", backgroundColor: BIBlue }}
                      className="active-btn"
                      onClick={() => {
                        handleExperience();
                        setShowMyExperienceHeading(false);
                      }}>
                      {editExperience ? BUTTON_BACK : BUTTON_EDIT}
                    </Button>
                  )} */}
                {(editExperience || company?.length === 0) && (
                  <Button
                    variant="contained"
                    sx={{ width: "fit-content", backgroundColor: BIBlue }}
                    className="active-btn"
                    onClick={() => setShowaddcompany(true)}>
                    {TEXT_ADD_COMPANY}
                  </Button>
                )}
              </Stack>
              {/* )} */}
            </>
          )}
        </Stack>
        <Stack sx={{ padding: "10px" }}>
          {isFormUserDashboard ? null : (
            <>
              {(sites?.length !== 0 || company?.length !== 0) && editExperience === false && (
                <Stack display={"flex"} alignItems={"flex-start"}>
                  <Button variant="text" onClick={() => viewList()}>
                    {siteFlag ? BUTTON_VIEW_BY_COMPANY : BUTTON_VIEW_BY_SITES}
                  </Button>
                </Stack>
              )}
              {addExperience ||
                (sites?.length === 0 && company?.length === 0 && (
                  <Typography> {TEXT_EXPERIENCE_DESCRIPTION}</Typography>
                ))}
              {addExperience && <Typography> {TEXT_EXPERIENCE_DESCRIPTION}</Typography>}
            </>
          )}
          <Stack spacing={1}>
            {siteFlag && !editExperience ? (
              sites.map((site, index) => (
                <Card className="pagelist-content" key={index} sx={{ p: 1 }}>
                  <Stack>
                    <Stack flexDirection={"row"} justifyContent={"space-between"} sx={{ pb: 1 }}>
                      <Typography>{site?.companyName}</Typography>
                    </Stack>
                  </Stack>
                  <Stack spacing={1}>
                    {site.data.map((item, index) => (
                      <Stack
                        className="pagelist-content"
                        flexDirection={"row"}
                        // spacing={1}
                        alignItems={"center"}
                        p={1}
                        key={index}
                        sx={{ border: "none", background: "#f2f2f2", borderRadius: "5px" }}>
                        <Stack>
                          <img
                            height={"70px"}
                            style={{
                              border: "1px solid #8D8D8D",
                              borderRadius: "10px"
                            }}
                            width={"70px"}
                            src={
                              item?.mainPictureUrl === ""
                                ? defaultProjectImage
                                : item?.mainPictureUrl
                            }
                            onError={(event) => (event.target.src = defaultProjectImage)}
                            alt="Project Info"></img>
                        </Stack>
                        <Stack pl={1}>
                          <Typography>{item?.projectName} </Typography>
                          <Typography>{item?.companyName}</Typography>
                          {item?.startDate !== null && item?.startDate !== "" ? (
                            <Typography variant="body2">
                              {moment(item?.startDate).format("MMM YYYY")} -{" "}
                              {item?.currentCompany === false
                                ? item?.endDate === null || item?.endDate === "Invalid date"
                                  ? null
                                  : moment(item?.endDate).format("MMM YYYY")
                                : TEXT_PRESENT}{" "}
                            </Typography>
                          ) : null}
                          {item?.description && <Typography>{item?.description}</Typography>}
                        </Stack>
                      </Stack>
                    ))}
                  </Stack>
                </Card>
              ))
            ) : (
              <>
                {company.map((comp, index) => (
                  <Card className="pagelist-content" sx={{ p: 1, cursor: "pointer" }} key={index}>
                    <Stack onClick={() => onCompanyselect(comp)}>
                      <Stack flexDirection={"row"} justifyContent={"space-between"}>
                        <Stack>
                          <Typography>{comp?.companyName}</Typography>
                          <Typography>{comp?.roleName}</Typography>
                        </Stack>
                        {editExperience ? (
                          <Stack flexDirection={"row"} gap={"10px"} alignItems={"center"}>
                            <Tooltip title={TEXT_ADD_PROJECT}>
                              <AddIcon
                                style={{
                                  fontSize: "28px",
                                  color: BIBlue,
                                  cursor: "pointer"
                                }}
                                onClick={(e) => onAddProject(e, comp)}
                              />
                            </Tooltip>
                            <Tooltip title={TEXT_EDIT_COMPANY}>
                              <EditIcon
                                style={{ color: BIBlue, cursor: "pointer" }}
                                onClick={(e) => onCompanyedit(e, comp)}></EditIcon>
                            </Tooltip>
                          </Stack>
                        ) : null}
                      </Stack>
                      {comp?.startDate !== null ? (
                        <ListItemText
                          sx={{ m: 0, pb: 1 }}
                          secondary={
                            <Stack>
                              <span>
                                {moment(comp?.startDate).format("MMM YYYY")} -{" "}
                                {comp?.currentCompany === false
                                  ? comp?.endDate === null || comp?.endDate === "Invalid date"
                                    ? null
                                    : moment(comp?.endDate).format("MMM YYYY")
                                  : TEXT_PRESENT}
                              </span>
                            </Stack>
                          }
                        />
                      ) : null}
                      <Typography>{comp?.description}</Typography>
                    </Stack>
                    <Stack spacing={1}>
                      {comp?.data.map((item, index) => (
                        <Stack
                          // spacing={1}
                          className="pagelist-content"
                          flexDirection={"row"}
                          gap={1}
                          alignItems={"center"}
                          padding={"10px"}
                          position={"relative"}
                          onClick={(e) => onProjectselect(e, item, comp)}
                          key={index}
                          sx={{ border: "none", background: "#f2f2f2", borderRadius: "5px" }}>
                          <Stack>
                            <img
                              height={"70px"}
                              width={"70px"}
                              style={{
                                border: "1px solid #8D8D8D",
                                borderRadius: "10px"
                              }}
                              src={
                                item?.mainPictureUrl === ""
                                  ? defaultProjectImage
                                  : item?.mainPictureUrl
                              }
                              onError={(event) => (event.target.src = defaultProjectImage)}
                              alt="Construction Project"></img>
                          </Stack>
                          <Stack sx={{ margin: 0 }}>
                            <Typography>{item?.projectName}</Typography>
                            <Typography>{item?.siteName}</Typography>
                            {item?.startDate !== null && item?.startDate !== "" ? (
                              <Typography variant="body2">
                                {moment(item?.startDate).format("MMM YYYY")} -{" "}
                                {item?.present === false
                                  ? item?.endDate === null || item?.endDate === "Invalid date"
                                    ? null
                                    : moment(item?.endDate).format("MMM YYYY")
                                  : TEXT_PRESENT}{" "}
                              </Typography>
                            ) : null}
                            {item?.description && (
                              <Typography style={{ wordBreak: "break-word" }}>
                                {item?.description}
                              </Typography>
                            )}
                          </Stack>
                          {isFormUserDashboard ? (
                            <>
                              {workHistoryCommonSites.some((pro) => pro?.id === item?.projectId) ? (
                                <img
                                  src={mapMarkerYellow}
                                  alt="Contact profile pic"
                                  style={{
                                    height: "28px",
                                    position: "absolute",
                                    right: "15px",
                                    top: "35px"
                                  }}
                                />
                              ) : null}
                            </>
                          ) : (
                            <>
                              {editExperience && (
                                <Tooltip title={TEXT_EDIT_PROJECT}>
                                  <EditIcon
                                    style={{
                                      color: BIBlue,
                                      position: "absolute",
                                      right: "15px",
                                      top: "10px",
                                      cursor: "pointer"
                                    }}
                                    onClick={(e) => onProjectedit(e, item, comp)}></EditIcon>
                                </Tooltip>
                              )}
                            </>
                          )}
                        </Stack>
                      ))}
                    </Stack>
                  </Card>
                ))}
              </>
            )}
          </Stack>
        </Stack>
      </Card>
      <Addcompany
        allCompanies={allCompanies}
        getExperience={getExperience}
        companyId={companyId}
        showAddcompany={showAddcompany}
        handleClose={handleClose}
      />
      {viewExperience && (
        <Viewexperience
          projectData={projectData}
          viewExperience={viewExperience}
          onClose={() => setViewexperience(false)}
        />
      )}
    </>
  );
}
